import styled from 'styled-components';
import // COLOR,
// FONT
'assets';

export const CouponFormStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
  .group_form {
    .line_input {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      &.no_margin_bottom {
        margin-bottom: 0px;
      }
      .left_layout {
        width: 70px;
        margin-right: 5px;
      }
      .right_layout {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 166px;
        &.text_right {
          justify-content: flex-end;
        }
        .obj_1 {
          width: 35%;
        }
        .obj_2 {
          width: 44%;
        }
        .button_layout {
          margin-left: 5px;
        }
      }
    }
  }
`;
